<template>
  <el-pagination
    @size-change="handleSizeChange"
    @current-change="handleCurrentChange"
    :current-page="currentPage"
    :page-sizes="[10, 20, 50, 100]"
    :page-size="pageSize"
    layout="total, sizes, prev, pager, next, jumper"
    :total="total"
  >
  </el-pagination>
</template>

<script>
import eventBus from "@/utils/eventBus.js";

export default {
  props: {
    total: {
      type: Number,
      default: 100,
    },
  },
  created() {
    eventBus.$on("footPage-Change", this.currentInit);
  },
  destroyed() {
    eventBus.$off("footPage-Change", this.currentInit);
  },
  data() {
    return {
      pageSize: 10,
      currentPage: 1,
    };
  },
  methods: {
    handleSizeChange(val) {
      this.pageSize = val;
      // console.log(`每页 ${this.pageSize} 条`);
      this.$emit("get-data", { pageNumber: this.currentPage, pageSize: val });
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      // console.log(`当前页: ${val}`);
      this.$emit("get-data", { pageNumber: val, pageSize: this.pageSize });
    },
    currentInit(val) {
      this.currentPage = val;
    },
  },
};
</script>

<style></style>
